import type { Dispatch, SetStateAction } from 'react';
import ChevronRight from '@/assets/icons/ChevronRight.svg';
import type { NavLinkProps } from '@/types';
import { checkHasSubmenu } from './checkHasSubmenu';
import * as Styled from './MenuToggle.styled';
import { NavItem } from './NavItem';

interface LinkSectionProps {
  links: NavLinkProps[];
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setIsSubmenuOpen: Dispatch<SetStateAction<boolean>>;
  setSubmenuData: Dispatch<SetStateAction<NavLinkProps | null>>;
}

export const ProductLinks = ({
  links,
  setIsOpen,
  setIsSubmenuOpen,
  setSubmenuData,
}: LinkSectionProps) => {
  const handleSubmenuButtonClick = (link: NavLinkProps | null) => () => {
    setIsOpen(true);
    setIsSubmenuOpen(true);
    setSubmenuData(link);
  };

  return (
    <Styled.ProductLinks aria-label="Product navigation">
      <ul>
        {links.map(link =>
          checkHasSubmenu(link) ? (
            <li key={link.href}>
              <Styled.SubMenuToggle
                isButton={true}
                handler={handleSubmenuButtonClick(link)}
                $highlightColour={link.highlightColour}
              >
                {link.textContent}
                <ChevronRight />
              </Styled.SubMenuToggle>
            </li>
          ) : (
            <NavItem key={link.href} link={link} />
          ),
        )}
      </ul>
    </Styled.ProductLinks>
  );
};
